import { Button, HStack, Icon, Stack } from '@genial/components';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../components/TableContent';
import { tableHead } from '../constants';

import { LogoWithName } from './components/LogoWithName';
import { TableContentItemStatus } from './components/TableContentItemStatus';

import { TransferRequestsItemProps } from '.';

export const TransferRequestsItemDesktop: React.FC<TransferRequestsItemProps> = ({
  item,
  onPressDetails,
}) => {
  const getFlex = (index: number) => {
    const currentHead = tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <Stack px="inline.xxxs">
      <TableContent direction="row">
        <TableContentItemColumn flex={getFlex(0)}>
          <HStack space="inline.quarck" alignItems="center" justifyContent="space-between">
            <LogoWithName logoUrl={item.sourceLogoUrl} name={item.sourceNameNormalized} />
            <Icon name="ArrowRight" size="xs" color="neutral.light" />
          </HStack>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(1)}>
          <LogoWithName logoUrl={item.destinationLogoUrl} name={item.destinationNameNormalized} />
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(2)}>
          <TableContentItemText>{item.requestedByWayOfNormalized}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(3)}>
          <TableContentItemText>{item.protocolNormalized}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(4)}>
          <TableContentItemText>{item.requestDateNormalized}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(5)}>
          <TableContentItemStatus statusIcon={item.statusIcon} status={item.status} />
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(6)}>
          <Button
            variant="textLink"
            color="brand.tertiary.principal"
            onPress={() => onPressDetails(item.protocolNormalized)}
            rightIcon={<Icon name="ChevronRight" size="xxs" color="brand.tertiary.principal" />}>
            VER DETALHES
          </Button>
        </TableContentItemColumn>
      </TableContent>
    </Stack>
  );
};
